export const STORAGE_KEYS = {
  PACIENTES: "pacientes",
  TURNOS: "turnos",
  TRATAMIENTOS: "tratamientos",
  USUARIO_ACTUAL: "usuarioActual",
}